/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  DtpNoContent,
} from 'dtp-react-components';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { manterApenasFiltro } from '../utils/helpers';
import { solicitarHabilitarQualificacao } from '../utils/requests';
import './Inicio.css';
import InfoCronograma from '../pages/cadastros/cronograma-pagamentos/InfoCronograma';
import '../pages/cadastros/cronograma-pagamentos/impressaoCronogramaPagamento.css';
import { Button } from '../components';

// const STYLES_CSS = {
//   painelGeral: {
//     textAlign: 'left',
//     margin: '0 auto',
//   },
// };

class Inicio extends Component {
  componentDidMount() {
    manterApenasFiltro('');
    if (!this.props.configuracoesFrontend) {
      solicitarHabilitarQualificacao();
    }
    // solicitarPendenciasPorEnteLogado();
  }

  getMessage = (chave) => {
    let texto = '';
    if (this.props.configuracoesFrontend && this.props.configuracoesFrontend.listaMensagens) {
      const mensagem = this.props.configuracoesFrontend.listaMensagens.filter(m => m.chave === chave);
      if (mensagem.length > 0) {
        texto = mensagem[0].valor;
      }
    }
    return texto;
  }

  showPendencia = (visao) => {
    this.props.history.push(`/controledepagamentos/home/${visao}/pendencias`);
  }

  montaLinkPendencias = (visao) => {
    let textoVisao = '';
    let nomeParticipante = '';

    if (visao === 1) {
      textoVisao = 'análise de pagamento';
    }
    if (visao === 2) {
      textoVisao = 'valores a pagar';
    }

    if (this.props.configuracoesFrontend && this.props.configuracoesFrontend.nomeParticipantePendencia) {
      nomeParticipante = this.props.configuracoesFrontend.nomeParticipantePendencia;
    }

    const botaoLink = (
      <span style={
          {
            align: 'left',
            top: '-4px',
            position: 'relative',
          }
        }
      >
        <Button
          hint={(this.props.configuracoesFrontend && nomeParticipante) ?
            `Pendências de ${textoVisao} identificados para o ente ${nomeParticipante}.` : ''}
          icon="ico-money-bag"
          mini
          onClick={() => this.showPendencia(visao)}
        />
      </span>
    );

    const textoLink = (
      <span style={{ color: '#C32F27' }}>
        {(this.props.configuracoesFrontend && nomeParticipante) ? `Pendências de ${textoVisao} identificadas para o ente ${nomeParticipante}.` : ''}
      </span>
    );

    return (
      <React.Fragment>
        {botaoLink}{textoLink}
      </React.Fragment>
    );
  }

  mensagemBloqueio = () => {
    const urlComprev = 'https://servicos.dataprev.gov.br/comprev/';
    const urlParagrafoQuatro = 'https://www.gov.br/trabalho-e-previdencia/pt-br/assuntos/previdencia-no-servico-publico/compensacao-previdenciaria/compensacao-previdenciaria';
    const emailDataprev = 'comprev@dataprev.gov.br';
    const urlcomplementoCinco = 'https://docs.dataprev.gov.br/docs/comprev/perguntas-frequentes/';
    let paragrafoUm = '';
    let paragrafoDois = '';
    let paragrafoTres = '';
    let paragrafoQuatro = '';
    let paragrafoCinco = '';
    let complementoUm = '';
    let complementoDois = '';
    let complementoTres = '';
    let complementoQuatro = '';
    let complementoCinco = '';

    paragrafoUm = (
      <p>
        A contratação do COMPREV será realizada por meio do marketplace (<a href={urlComprev}>{urlComprev}</a>).
        Não é possível a celebração do contrato por outro canal.
      </p>);
    paragrafoDois = (
      <p>
        O primeiro passo antes de iniciar o processo de contratação do COMPREV junto à DATAPREV,
        é importante que o Ente se certifique que está devidamente habilitado pela SPREV para contratar o COMPREV.
      </p>);
    paragrafoTres = (
      <p>
        Após a celebração do Termo de Adesão junto a SPREV, o Ente está apto para realizar a contratação do COMPREV junto à DATAPREV.
      </p>);
    paragrafoQuatro = (
      <p>
        Para tanto, o Ente deverá acessar o portal da SPREV <a href={urlParagrafoQuatro}>{urlParagrafoQuatro}</a> e acessar
        os documentos (Projeto Básico, Minuta de Contrato e Modelo de Negócio) que serão necessários para o Ente instaurar o processo
        administrativo de contratação do COMPREV. É importante que o Ente siga as recomendações de preenchimento presentes nesses documentos e que
        não utilize outros documentos que não sejam aqueles disponibilizados no portal da SPREV.
      </p>);
    paragrafoCinco = (
      <p>
        Após a conclusão das etapas internas relativas à contratação, o Ente deverá acessar o marketplace da DATAPREV <a href={urlComprev}>{urlComprev}</a> e
        preencher o formulário eletrônico com todas as informações solicitadas.
      </p>);
    complementoUm = (
      <p>
        Existem dois canais de relacionamento para dirimir dúvidas com os Entes relacionadas à Contratação do COMPREV.
      </p>);
    complementoDois = (
      <p>
        1 – Sala Virtual, sempre terças e quintas, das 09:30h às 12:00h e 14:30 às 17:00. Para solicitar acesso e participar, basta ligar para o número (61) 2021-5555.
      </p>);
    complementoTres = (
      <p>
        2 – Caixa de Email do COMPREV: <a href={`mailto:${emailDataprev}`}>{emailDataprev}</a>
      </p>);
    complementoQuatro = (
      <p>
        Segue link do FAQ relacionado à contratação do COMPREV.
      </p>);
    complementoCinco = (
      <p>
        <a href={urlcomplementoCinco}>{urlcomplementoCinco}</a>
      </p>);
    return (
      <React.Fragment>
        {paragrafoUm}
        {paragrafoDois}
        {paragrafoTres}
        {paragrafoQuatro}
        {paragrafoCinco}
        {complementoUm}
        {complementoDois}
        {complementoTres}
        {complementoQuatro}
        {complementoCinco}
      </React.Fragment>
    );
  }

  render() {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
        {this.props.configuracoesFrontend && this.props.configuracoesFrontend.exibirLinkPesquisaPendenciasAReceber &&
          <div className="esconder-print">
            <h2
              style={
                {
                  fontSize: '20px',
                  // fontWeight: '600',
                  textAlign: 'left',
                  paddingLeft: '35px',
                }
              }
            >
              {this.montaLinkPendencias(1)}
            </h2>
          </div>
        }
        {this.props.configuracoesFrontend && this.props.configuracoesFrontend.exibirLinkPesquisaPendenciasAPagar &&
          <div className="esconder-print">
            <h2
              style={
                {
                  fontSize: '20px',
                  // fontWeight: '600',
                  textAlign: 'left',
                  paddingLeft: '35px',
                }
              }
            >
              {this.montaLinkPendencias(2)}
            </h2>
          </div>
        }
        {this.props.configuracoesFrontend &&
          <div id="alerta-bloqueio">
            <DtpNoContent
              primaryText={this.mensagemBloqueio()}
              show={this.props.configuracoesFrontend.temBloqueioAtivoContratoDtp}
            />
          </div>
        }
        <div className="esconder-print">
          <DtpNoContent
            primaryText={this.getMessage('msgprimaria')}
            secondaryText={this.getMessage('msgsecundaria')}
            show="true"
          />
        </div>
        <InfoCronograma />
      </div>
    );
  }
}

Inicio.defaultProps = {
  configuracoesFrontend: null,
};

Inicio.propTypes = {
  configuracoesFrontend: PropTypes.arrayOf(PropTypes.string),
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};

const mapStateToProps = state => ({
  filtroBloqueio: state.base.filtroBloqueio,
  configuracoesFrontend: state.base.configuracoesFrontend,
});

export default connect(mapStateToProps)(Inicio);



// WEBPACK FOOTER //
// ./src/pages/Inicio.jsx